import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-main-header',
    templateUrl: './app-main-header.component.html',
    styleUrls: ['./app-main-header.component.scss'],
    standalone: false
})
export class AppMainHeaderComponent implements OnInit {

  ngOnInit(): void {
  }

}
